module.exports = __webpack_public_path__ + "img/pic_1.7ec8ae24.png";